
function StageApprovalsCtrl(TranslationService, UserSettingService) {
    var ctrl = this;
    ctrl.translation = TranslationService.getActiveTranslation();
    ctrl.width = 100;

    ctrl.users = [];

    ctrl.searchUsers = function (query) {
        return UserSettingService.getUsersQuery(query)
            .then(function (response) {
                var resp = response.data.map(function (item) {
                    return {
                        UserID: item.Key,
                        text: item.Key, //componente obriga
                    };
                });                
                ctrl.users = resp;
                return resp;
            })
            .catch(function (err) {
                console.error(err);
            });
    };

    ctrl.$onInit = function () {
        ctrl.searchUsers('');
    };

    ctrl.applyStages = function (approval) {
        if (approval) {
            approval.userIDs = approval.Users.map(function (user) {
                return user.UserID;
            })
        }
    };

    ctrl.add = function (index) {
        var newField = {
            Users: []
        };
        if (!ctrl.approvals) {
            ctrl.approvals = [];
        }
        ctrl.approvals.push(newField);
    };

    ctrl.delete = function (index) {
        ctrl.approvals.splice(index, 1);
        ctrl.applyStages();
    };

    ctrl.findUser = function (users, userID) {
        return users.findIndex(function (user) {
            return user.UserID == userID;
        });
    };

    ctrl.selectUser = function (approval, user) {
        //console.log('select option ', approval, user);
        //ctrl.approvals[index] = option.StageID;

        var index = ctrl.findUser(approval.Users, user.UserID);
        if (index >= 0) {
            approval.Users.splice(index, 1);
            //approval.Users[index]
        }
        else {
            var newUser = {
                UserID: user.UserID
            }
            approval.Users.push(newUser);
        }
        ctrl.applyStages(approval);
    };

    ctrl.isUserSelected = function (approval, option) {
        if (!approval.Users) {
            return false;
        }
        var find = approval.Users.find(function (u) {
            return u.UserID == option.UserID;
        });
        return find;
    };
}

StageApprovalsCtrl.$inject = ['TranslationService', 'UserSettingService'];

seedWebApp.component('stageApprovals', {
    controller: StageApprovalsCtrl,
    controllerAs: 'ctrl',
    bindings: {
        stage: '<',
        approvals: '=',
    },
    templateUrl: '/SPA/settings/stages/stageApprovals.html' + seedWebApp.buildVersion
});
